import React from "react";

// Style
import "./style.css";

export default function Loader() {
  return (
    <div className="loader-container">
      <div className="loader-wrapper">
        <div className="loader">Loading...</div>
      </div>
    </div>
  );
}
